import styled from "styled-components";

const Spacer = styled.div`
  display: flex;
  flex-grow: 1;
`;

export default Spacer;
